var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button-filter",class:_vm.filterButtonClass,attrs:{"data-location":_vm.location,"type":"button"},on:{"click":function($event){_vm.filterExpanded = !_vm.filterExpanded}}},[_c(_vm.iconType,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }